import { css } from 'styled-components';
import lightGlobalCss from './colorGlobal.css';
import darkGlobalCss from './colorGlobalDark.css';

export const lightGlobalTokens = css`
  ${lightGlobalCss}
`;

export const darkGlobalTokens = css`
  ${darkGlobalCss}
`;
